import {apiGet} from "./api";

export const getSupportedOffices = (onSuccess) => apiGet('/support/office', onSuccess, undefined, {});
